import type { ReactNode } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
   ModelParameterEditor,
   type ModelParameterItem,
} from "@/components/models/ModelParameterEditor";

interface ModelDetailViewProps {
   modelId: string;
   parameters: ModelParameterItem[];
   readOnly?: boolean;
   onModelIdChange?: (value: string) => void;
   onParametersChange?: (parameters: ModelParameterItem[]) => void;
   providerSlot: ReactNode;
}

export function ModelDetailView({
   modelId,
   parameters,
   readOnly = false,
   onModelIdChange,
   onParametersChange,
   providerSlot,
}: ModelDetailViewProps) {
   return (
      <div className="flex flex-col gap-6">
         <div className="flex flex-col gap-6 rounded-xl border border-slate-200 bg-card p-6 text-card-foreground shadow-sm dark:border-slate-700">
            <h2 className="text-sm font-semibold text-slate-900">Model Configuration</h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
               <div className="space-y-2">
                  <Label>Provider</Label>
                  {providerSlot}
               </div>
               <div className="space-y-2">
                  <Label htmlFor="model-identifier">Model ID</Label>
                  <Input
                     id="model-identifier"
                     value={modelId}
                     disabled={readOnly}
                     onChange={(e) => onModelIdChange?.(e.target.value)}
                     placeholder="e.g. gpt-4o"
                     className="font-mono"
                  />
                  <p className="text-xs text-slate-500">Provider&apos;s model identifier</p>
               </div>
            </div>
         </div>

         <div className="flex flex-col gap-6 rounded-xl border border-slate-200 bg-card p-6 text-card-foreground shadow-sm dark:border-slate-700">
            <h2 className="text-sm font-semibold text-slate-900">Parameter Configuration</h2>
            <ModelParameterEditor
               parameters={parameters}
               readOnly={readOnly}
               onChange={onParametersChange ?? (() => {})}
            />
         </div>
      </div>
   );
}
